import React, { Component } from 'react'
import Slider from 'components/fulcrum/slider/Slider'

class StepSlider extends Component {
  render() {
    const {
      step,
      ...sliderProps,
    } = this.props

    return (
      <Slider step={step} {...sliderProps} />
    )
  }
}

export default StepSlider
